// Auto-generated by "pnpm lingui:translate create-language-file-list"
// eslint-disable-next-line lingui/no-unlocalized-strings
export const availableMessages = ["zh", "fr", "es", "en", "de", "ko", "th"];
export type AvailableMessages = (typeof availableMessages)[number];
